import { ScheduleApi, Schedule } from '../models';

export function mapScheduleApiToSchedule(scheduleApi: ScheduleApi): Schedule {
  return {
    id: scheduleApi.id,
    Mo: Boolean(scheduleApi.Mo),
    Tu: Boolean(scheduleApi.Tu),
    We: Boolean(scheduleApi.We),
    Th: Boolean(scheduleApi.Th),
    Fr: Boolean(scheduleApi.Fr),
    Sa: Boolean(scheduleApi.Sa),
    Su: Boolean(scheduleApi.Su),
    from: scheduleApi.from,
    to: scheduleApi.to,
    costMode: scheduleApi.costMode,
    driverId: scheduleApi.driverId,
  };
}
